import { getVisitaOfflineEntry, acknowledgeVisitaDraft } from './visitaOfflineQueue.js';
import { getVisitaOfflineOperationsByVisita } from './visitaOfflineOperationQueue.js';
import { getVisitaSyncPayload, hasPendingVisitaStructure, withVisitaSyncLock } from './visitaLocalFirst.js';
import { withVisitaSyncTransfer } from './visitaSyncStatus.js';
import {flushMergeDraft} from './visitaMergeSync.js';
import {removeVisitaOfflineEntry} from './visitaOfflineQueue.js';

// Todos los emisores JS comparten la misma barrera y vuelven a leer la revisión vigente.
export function flushQueuedVisitaDraft({ userId, visitaId, send, isCurrent = () => true, allowCausalRebase = true }) {
    return withVisitaSyncLock(userId, visitaId, async () => {
        if (!isCurrent()) return { blocked: true, identityChanged: true, applied: false };
        const operations = await getVisitaOfflineOperationsByVisita(visitaId, userId);
        if (hasPendingVisitaStructure(operations, visitaId)) return { blocked: true, applied: false };
        const entry = await getVisitaOfflineEntry({ userId, visitaId });
        if (!entry?.payload) return { applied: true, empty: true };
        if (entry.payload._merge) return withVisitaSyncTransfer(userId,visitaId,()=>flushMergeDraft(entry,send,{
            isCurrent,allowCausalRebase,
            remove:async original=>{
                if (!isCurrent()) return false;
                const current=await getVisitaOfflineEntry({userId,visitaId});
                if(current?.revisionId!==original.revisionId)return false;
                await removeVisitaOfflineEntry({userId,visitaId,expectedRevisionId:original.revisionId});
                return !(await getVisitaOfflineEntry({userId,visitaId}));
            }
        }));
        const payload = getVisitaSyncPayload(entry.payload);
        return withVisitaSyncTransfer(userId, visitaId, async () => {
            const response = await send(payload, {
                idempotencyKey: `draft:${entry.userId}:${entry.visitaId}:${entry.revisionId}`,
                revisionId: entry.revisionId,
            });
            const data = response?.data || response || {};
            if (!isCurrent()) return { entry, data, applied: false, blocked: true, identityChanged: true };
            const applied = await acknowledgeVisitaDraft(entry, data, {
                confirmedNoChanges: Object.keys(payload).length === 0 && data.status === 'no_changes',
            });
            return { entry, data, applied };
        });
    });
}
